var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArkc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5889 0H10.4111C7.64988 0 5.00179 1.09688 3.04933 3.04933C1.09688 5.00178 0 7.64988 0 10.4111V21.5889C0 24.3501 1.09688 26.9982 3.04933 28.9507C5.00179 30.9031 7.64988 32 10.4111 32H21.5889C24.3501 32 26.9982 30.9031 28.9507 28.9507C30.9031 26.9982 32 24.3501 32 21.5889V10.4111C32 7.64988 30.9031 5.00178 28.9507 3.04933C26.9982 1.09688 24.3501 0 21.5889 0ZM9.5641 22.4446L11.6101 17.504L14.5047 20.3986L9.5641 22.4446ZM16.2283 21.5732L17.3663 18.811L13.1315 14.5814L10.3675 15.7281L8.20477 13.5637L21.3972 8.50975L23.4885 10.601L18.4433 23.8074L16.2283 21.5732Z",
    fill: "#8C52FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkc);
export default __webpack_public_path__ + "static/media/arkc.15be775841bdf2dc60be0e81f9863285.svg";
export { ForwardRef as ReactComponent };